import { useContentfulLiveUpdates } from "@contentful/live-preview/react"
import dynamic from "next/dynamic"

// ---------------------------------------------------------

const RecommendedReading = dynamic(() => import("@components/recommended-reading"), { ssr: false })

// ---------------------------------------------------------

import { fetchRecommended } from "@lib/fetchRecommended"
import FlexibleData from "@lib/flexibleData"
import RenderBlocks from "@lib/renderBlocks"
import Layout from "../../../layout"

// ---------------------------------------------------------

const { decorateSnippets } = require("../../../lib/snippets")

export async function getStaticProps(context) {
  const preview = process.env.NODE_ENV === "development" || context.draftMode || false
  const previewEnv = context?.previewData?.environment || null
  const _pageData = (await FlexibleData.fetch("demo", preview, previewEnv)) ?? []
  const pageData = await decorateSnippets(_pageData)

  const recommended = pageData.showRecommended
    ? await fetchRecommended(pageData?.recommendedCollection?.items, "webinars", "blogs", preview)
    : null

  return {
    props: {
      pageData,
      recommended,
      preview
    }
  }
}

const DemoIndexPage = (props) => {
  const { pageData, recommended, preview } = props

  const livePageData = useContentfulLiveUpdates(pageData)

  const pageModules = livePageData?.modulesCollection?.items ?? []
  let pageTitle = "Demos"
  let excerpt = "Demos"

  return (
    <Layout preview={preview} pageTitle={pageTitle} excerpt={excerpt}>
      {pageModules && RenderBlocks(pageModules)}

      {recommended && (
        <RecommendedReading
          recommended={recommended}
          title="Explore Blogs"
          buttonLabel="View all blogs"
          buttonUrl="/blog"
        ></RecommendedReading>
      )}
    </Layout>
  )
}

export default DemoIndexPage
